let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gn77S")).then(() => parcelRequire('c435L'));